import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "ticket-id",
  value: "rent-cart"
}, null, -1)
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "intersport-sidebox__header" }
const _hoisted_5 = { class: "intersport-sidebox__title" }
const _hoisted_6 = { class: "intersport-sidebox__header-info font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-poi" }, null, -1)
const _hoisted_8 = { class: "intersport-sidebox__timespan-header-text" }
const _hoisted_9 = { class: "intersport-sidebox__header-info" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-calendar" }, null, -1)
const _hoisted_11 = { class: "intersport-sidebox__header-info-text" }
const _hoisted_12 = { class: "list-unstyled intersport-sidebox__people-list" }
const _hoisted_13 = { class: "intersport-sidebox__people-list-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-accordeon-open btn-icon-text__icon" }, null, -1)
const _hoisted_15 = { class: "intersport-sidebox__total-price-with-tag" }
const _hoisted_16 = { class: "intersport-sidebox__total-price-tag" }
const _hoisted_17 = { class: "intersport-sidebox__footer" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-bag cart-sidebox__button-icon",
  "aria-hidden": "true"
}, null, -1)

import {watch, computed, onMounted, onUpdated} from "vue";
// @ts-ignore
import { ISOStringToDate } from "@elements/date-utils";
// @ts-ignore
import {find, on} from "@elements/dom-utils";
// @ts-ignore
import {translate} from "@elements/translations";
// @ts-ignore
import { PeopleStore } from "../types/intersport.ts";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import {useSearchStore} from "../stores/SearchStore.ts";
import {usePeopleStore} from "../stores/PeopleStore.ts";
import {useProductsStore} from "../stores/ProductStore.ts";
import * as affix from '../../scripts/elements-packages/affix';
import Price from "./components/Price.vue";
import IntersportPerson from "./components/IntersportPerson.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntersportSidebox',
  props: {
    peopleJson: {},
    peopleRequestUrl: {},
    profileRequestUrl: {},
    availabilityRequestUrl: {},
    addToCartUrl: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-ignore


const searchStore = useSearchStore();
const peopleStore = usePeopleStore();
const productStore = useProductsStore();
let scrollTop = false;

peopleStore.fillStore(props.peopleJson);
peopleStore.setRequestUrl(props.peopleRequestUrl);
productStore.setAvailabilityRequestUrl(props.availabilityRequestUrl);

onMounted(() => {
  if (props.profileRequestUrl) {
    peopleStore.setProfileRequestUrl(props.profileRequestUrl);
  }

  affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
    base: '.js-affix-sidebox',
    placeholder: '.js-affix-sidebox__placeholder',
    container: '.js-affix-sidebox__container'
  });

  on('scroll', () => {
    if (scrollTop && document.body.scrollTop === 0 && document.documentElement.scrollTop === 0) {
      affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
        base: '.js-affix-sidebox',
        placeholder: '.js-affix-sidebox__placeholder',
        container: '.js-affix-sidebox__container'
      });
      scrollTop = false;
    }
  }, window)
});

onUpdated(() => {
  if (!productStore.loading || !peopleStore.loadingObject.loading) {
    let affixSidebox = find('.js-affix-sidebox');

    if (affixSidebox.getBoundingClientRect().height >= (window.innerHeight - find('.js-affix-nav').offsetHeight)) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      scrollTop = true;
    } else {
      affix.createAffix(affixSidebox, {mediaQuery: '(min-width: 768px)'}, {
        base: '.js-affix-sidebox',
        placeholder: '.js-affix-sidebox__placeholder',
        container: '.js-affix-sidebox__container'
      });
    }
  }
});

const people = computed(() => {
  return peopleStore.getPeopleInfo();
})

const locationText = computed(() => {
  const location = searchStore.selectedLocation;
  if (Object.keys(location).length > 0) {
    return location.label;
  }
  return translate('instersport.select-location-text');
})

const dateString = computed(() => {
  if (searchStore.startDate) {
    let endDate = searchStore.endDate ? ISOStringToDate(searchStore.endDate).toLocaleDateString() : translate('intersport.sidebox-pick-to-date')
    return `${ISOStringToDate(searchStore.startDate).toLocaleDateString()} - ${endDate}`;
  }
  return translate('instersport.select-date-range-text');
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    method: "post",
    action: _ctx.addToCartUrl,
    class: "position-relative"
  }, [
    (_unref(productStore).loading || _unref(peopleStore).loadingObject.loading)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(translate)('intersport.sidebox-title')), 1),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(locationText.value), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(dateString.value), 1)
        ])
      ]),
      _createElementVNode("ul", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(people.value, (person) => {
          return (_openBlock(), _createBlock(IntersportPerson, {
            id: person.id,
            "birth-date": person.birthDate,
            "last-name": person.lastName,
            "first-name": person.firstName,
            "additional-data": person.additionalData
          }, null, 8, ["id", "birth-date", "last-name", "first-name", "additional-data"]))
        }), 256)),
        _createElementVNode("li", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-nostyling btn-icon-text intersport-sidebox__add-person-btn",
            "data-bs-target": "#intersport-person-modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(peopleStore).openModal()))
          }, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_unref(translate)('intersport.sidebox-add-person')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(translate)('intersport.sidebox-total-price-text')), 1),
        _createElementVNode("strong", null, [
          _createVNode(Price, {
            value: _unref(productStore).getSideboxTotalPrice()
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary intersport-sidebox__button",
        disabled: _unref(productStore).getSelectedAvailabilities().length === 0
      }, [
        _hoisted_19,
        _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.sidebox-add-to-cart')), 1)
      ], 8, _hoisted_18)
    ])
  ], 8, _hoisted_1))
}
}

})